import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";

import CharacterImage from "assets/images/hero-unit/character.png";
import ConfettiImage from "assets/images/hero-unit/confetti.png";
import ConfettiTabletImage from "assets/images/hero-unit/confetti-tablet.png";

export const Root = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.cornflowerBlue,
  backgroundImage: `url(${CharacterImage}), url(${ConfettiImage})`,
  backgroundSize: "75%, cover",
  backgroundRepeat: "no-repeat, no-repeat",
  backgroundPosition: "right bottom, center",
  [theme.breakpoints.up("mobile")]: {
    backgroundImage: `url(${CharacterImage}), url(${ConfettiTabletImage})`,
    backgroundPosition: "65%, center",
    backgroundSize: "contain, cover",
  },
}));

export const Content = styled("div")(({ theme }) => ({
  padding: "1.4rem 0 2rem",
  [theme.breakpoints.up("mobile")]: {
    padding: "4rem 0 6rem 4.5rem",
  },
  [theme.breakpoints.up("tablet")]: {
    padding: "4rem 0 6rem 5rem",
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  marginBottom: 5,
  color: theme.palette.common.white,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 9,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 15,
  },
}));

export const Tagline = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  marginBottom: 15,
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 34,
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: "auto",
  height: "auto",
  padding: "2px 18px 0",
  fontSize: ".7rem",
  lineHeight: "49px",
  color: "#222e40",
  backgroundColor: "#5fe0df",
  border: "none",
  cursor: "pointer",
  boxShadow: "0 3px 6px transparent, 0 3px 6px transparent",
  transition: "box-shadow .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)",
  borderRadius: 100,
  "&:hover": {
    backgroundColor: "#5fe0df",
    color: theme.palette.common.white,
    transform: "scale(1.1)",
  },
  [theme.breakpoints.up("mobile")]: {
    padding: "3px 23px 0",
    fontSize: "1rem",
    lineHeight: "56px",
  },
  [theme.breakpoints.up("tablet")]: {
    padding: "3px 66px 0",
    fontSize: "1.6rem",
    lineHeight: "74px",
  },
}));
